import axios from "axios";
import { URL } from "../Home/api";

export const loginApi = async (data) => {
  try {
    const response = await axios.post(`${URL}api/login`, data);
    alert("Login berhasil!");
    return response;
  } catch (error) {
    alert("Login gagal: " + error.response?.data?.message || error.message);
  }
};

// export const checkTokenApi = async () => {
//   const accessToken = sessionStorage.getItem("token_login");

//   axios
//     .get(`${url}/auth/check-token/`, {
//       headers: {
//         Authorization: `Bearer ${accessToken}`,
//       },
//     })
//     .then((response) => {
//       console.log("✅ Token valid:", response.data);
//     })
//     .catch((error) => {
//       console.warn("⛔ Token tidak valid atau expired", error.response?.data);
//       // Tambahkan logika redirect atau refresh token di sini jika perlu
//       sessionStorage.removeItem("access");
//       sessionStorage.removeItem("refresh");
//       sessionStorage.removeItem("token_login");

//       window.location.href = "/";
//     });
// };
